// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import RunningRoundSvg from '@rsuite/icon-font/lib/status/RunningRound';
var RunningRound = createSvgIcon({
  as: RunningRoundSvg,
  ariaLabel: 'running round',
  category: 'status',
  displayName: 'RunningRound'
});
export default RunningRound;